Element.prototype.toggleClassName = function (target, force) {
    var d = this.className.split(" "), i = 0, found = false, c = "";
    while (i < d.length) {
        if (d[i] == target) {
            d.splice(i, 1);
            found = true;
        } else {
            c += (i == 0 ? "" : " ") + d[i];
            i++;
        }
    }
    if (force == true || (typeof force !== "boolean" && !found)) c += (i == 0 ? "" : " ") + target;
    this.className = c;

    return found;
}

window.resizer = {
    resizingDelay: 0,
    resizingTimeout: function () {
        try {
            window.clearTimeout(this.resizingTimeout);
        } catch (e) { }
        this.resizingDelay -= 10;
        if (this.resizingDelay <= 0) {
            this.resize();
        } else window.setTimeout(() => this.resizingTimeout(), 10);
    },
    resize: function () {
        var body = document.getElementsByTagName("body")[0];

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        var landscape = height * 1.1 >= width ? false : true;

        var res = width + height;
        if (res > 3000) res = "uhd";
        else if (res > 2500) res = "fhd";
        else if (res > 2000) res = "hd";
        else if (res > 1500) res = "sd";
        else if (res > 1000) res = "md";
        else res = "lw";
        this.resizingDelay = 0;
        body.toggleClassName("landscape", landscape);
        body.toggleClassName("portrait", !landscape);
        if (body.className.indexOf("bodysize_") < 0)
            body.className += " bodysize_" + res;
        body.className = body.className.replace(/\s*bodysize_[a-z]*(\s*bodysize_[a-z])*/ig, " bodysize_" + res);
    },
    sizes: {
        width: 0,
        height: 0
    }
}
window.addEventListener("resize", () => {
    window.resizer.resizingDelay = 200;
    window.resizer.resizingTimeout();
});

window.resizer.resize();

